// import from auth apis
import { muesApiSlice } from "../authentication/authentication";

export const broadcast=muesApiSlice.injectEndpoints({
    endpoints: builder =>({
        // list of query
        getBroadcastMessage : builder.query({
            query : (queryParams)=>({
                url: 'broadcast',
                method: 'GET',
                params: queryParams,
            }),
            providesTags:()=>[
                {type:"broadcast", id:"LIST"}
            ],
        }),
        getNotification : builder.query({
            query : (queryParams)=>({
                url: 'notification',
                method: 'GET',
                params: queryParams,
            }),
            providesTags:()=>[
                {type:"notification", id:"LIST"}
            ],
        }),
        getNotificationCount : builder.query({
            query : (queryParams)=>({
                url: 'unread-notification-count',
                method: 'GET',
                params: queryParams,
            }),
            providesTags:()=>[
                {type:"notificationCount", id:"LIST"}
            ],
            keepUnusedDataFor:0
        }),

        // list of mutation
        addBroadcastMessage : builder.mutation({
            query: (requestBody) => ({
                url: 'notification',
                method: 'POST',
                body: requestBody,
              }),
            invalidatesTags:()=>[
                {type:"broadcast", id:"LIST"}
            ]
        }),
        addShareAnInformation : builder.mutation({
            query: (requestBody) => ({
                url: 'share-an-information',
                method: 'POST',
                body: requestBody,
              }),
            invalidatesTags:()=>[
                {type:"shareAnInformation", id:"LIST"}
            ]
        }),
       
    })
})

export const {useGetBroadcastMessageQuery, useAddBroadcastMessageMutation, 
useAddShareAnInformationMutation, useGetNotificationQuery, useGetNotificationCountQuery}=broadcast